import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../index';

export const getRoofContainerGuidDuringEnvelopeInsertion = createSelector(
  (state: RootState) => state.application.insertingObjectInfo,
  (state: RootState) => state.layout.trussEnvelopes,

  (insertingObjectInfo, trussEnvelopes): string | null => {
    if (insertingObjectInfo?.type === 'trussEnvelope' && insertingObjectInfo.data.roofContainerGuid != null) {
      return insertingObjectInfo.data.roofContainerGuid;
    }

    if (insertingObjectInfo?.type === 'trussEnvelopeRun') {
      return trussEnvelopes[insertingObjectInfo.data.baseEnvelopeGuid]?.roofContainerGuid ?? null;
    }

    return null;
  },
);
